/*
 * @Author: Teemo Ding
 * @Date: 2021-11-30 15:31:38
 * @LastEditTime: 2021-12-16 18:32:22
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/AddressFields/index.tsx
 */
import React from 'react';
import { get } from 'lodash';
import { Form } from 'antd';
import { Input } from '@/src/components/Antd';
import CascaderObjectValue from '@/src/components/Antd/Cascader/CascaderObjectValue';
import { AddressFieldType } from '@/src/types/common/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
const AddressFields = ({ fields, provinces }) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  return (
    <div>
      {(fields || []).map((i) => {
        const name = get(i, 'fieldName') || [];
        const fieldType = get(i, 'fieldType');
        return (
          <Form.Item
            key={fieldType}
            name={fieldType}
            label={`${name} ${
              fieldType !== AddressFieldType.AddressLine2 ? '*' : ''
            }`}
            rules={[
              {
                required: fieldType !== AddressFieldType.AddressLine2,
                message: replaceI18nVariables(
                  getI18n('general.fieldisrequired'),
                  name,
                ),
              },
            ]}
            labelCol={{ span: 24 }}>
            {fieldType === AddressFieldType.Subdivision ? (
              <CascaderObjectValue
                size='large'
                fieldNames={{
                  label: 'label',
                  value: 'uuid',
                  children: 'children',
                }}
                options={provinces}
              />
            ) : (
              <Input size='large' />
            )}
          </Form.Item>
        );
      })}
    </div>
  );
};

export default AddressFields;
